export default "/images/no-profile-picture-icon.png?428dcf022311ef93e5f7b4300b89292b";